import type { TaskAction } from '@types';
import { API_DOMAIN } from '@constants';
import axios from '@utils/axios';
import { teamConfig } from '../../../utils/teamConfig';

type TaskType = 'pano' | 'pVideo' | 'matrix';
const urlMap: Record<TaskType, string> = {
  pano: '/member/my/panos/task',
  pVideo: '/member/my/video_v2/materials/task',
  matrix: '/member/my/matrix/materials/task',
};
const teamUrlMap: Record<TaskType, string> = {
  pano: '/team/app/tours/panos/task',
  pVideo: '/team/app/tours/videos/task',
  matrix: '/team/app/tours/matrixes/task',
};

interface RTResp {
  id: number;
  name: string;
  createDate: number;
  updateDate: number;
  albumId: number | '';
  action?: TaskAction;
}

async function fetchRunningTask(taskType: TaskType) {
  const map = teamConfig(urlMap, teamUrlMap);
  const url = map[taskType];
  if (!url) return;
  return axios.get<RTResp[]>(`${API_DOMAIN}${url}`);
}

export default fetchRunningTask;
